import React from 'react';

import RedirectAuthenticateView from '../components/RedirectAuthenticateView';

const RedirectAuthenticate = props => {
  return <RedirectAuthenticateView {...props} />;
};

export default RedirectAuthenticate;
